// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"6ed1f932","444":"a20abf63","787":"77c71de3","894":"dd02b161"}[chunkId] + ".chunk.js";
};